// * hooks
import axiosClient from "./axiosClient";
// * constants
import { apiUrls } from "../utils/urls";

const uploadFile = (file: Blob, token: string) => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("type", "POST");

  return axiosClient.post(apiUrls.postMedia, fd, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "multipart/form-data",
      //   transformRequest: (data, headers) => {
      //     return fd;
      //   },
    },
  });
};

const uploadBrand = (brandName: string, objectKey: string, token: string) => {
  return axiosClient.post(
    apiUrls.brand,
    {
      name: brandName,
      image: objectKey,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

/**
 *
 * @param {string} objectKey
 * @param {string | null} token
 * @returns
 */
const viewMedia = async (objectKey: string, token: string) => {
  const data = await axiosClient.get(apiUrls.media.replace(/%s/, objectKey), {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    responseType: "arraybuffer",
  });
  return data;
};

/**
 *
 * @param {string[]} objectKeyList
 * @param {string | null} token
 */
const viewMediaList = async (objectKeyList: string[], token: string) => {
  const queryList: any[] = [];
  objectKeyList.forEach((objectKey) => {
    queryList.push(viewMedia(objectKey, token));
  });
  return Promise.all(queryList);
};

const createNotification = (text: string, token: string) => {
  return axiosClient.post(
    apiUrls.notification,
    {
      text,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export {
  uploadFile,
  viewMedia,
  viewMediaList,
  uploadBrand,
  createNotification,
};
